var RenderData = /** @class */ (function () {
    function RenderData(data, last) {
        this._data = data;
        this._last = last;
    }
    Object.defineProperty(RenderData.prototype, "data", {
        get: function () {
            return this._data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderData.prototype, "last", {
        get: function () {
            return this._last;
        },
        enumerable: true,
        configurable: true
    });
    return RenderData;
}());
export { RenderData };
//# sourceMappingURL=render-data.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-dto/render/render-data.js
// module id = 996
// module chunks = 14